const getOffsetMinutesForTimezoneKey = (timezoneKey) => {
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: timezoneKey,
      timeZoneName: "shortOffset",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).formatToParts(new Date());

    const timezonePart = parts.find((part) => part.type === "timeZoneName")?.value ?? "GMT";
    if (timezonePart === "GMT" || timezonePart === "UTC") return 0;

    const match = timezonePart.match(/^(?:GMT|UTC)([+-])(\d{1,2})(?::?(\d{2}))?$/);
    if (!match) return 0;

    const sign = match[1] === "-" ? -1 : 1;
    const hours = Number(match[2]);
    const minutes = Number(match[3] ?? "0");

    return sign * (hours * 60 + minutes);
  } catch {
    return 0;
  }
};

export const getBrowserTimeDifference = (timezoneKey) => {
  if (!timezoneKey) return 0;

  const targetOffsetMinutes = getOffsetMinutesForTimezoneKey(timezoneKey);
  const browserOffsetMinutes = -new Date().getTimezoneOffset();
  const diffMinutes = targetOffsetMinutes - browserOffsetMinutes;

  return diffMinutes / 60;
};

export const getBrowserTimeDifferenceText = (timezoneKey) => {
  if (!timezoneKey) return "";

  const diffHours = getBrowserTimeDifference(timezoneKey);
  const diffMinutes = diffHours * 60;

  if (diffMinutes === 0) return "same as browser time";

  const absHours = Math.abs(diffHours);
  const hoursText = Number.isInteger(absHours)
    ? String(absHours)
    : absHours.toFixed(2).replace(/\.00$/, "").replace(/0$/, "");

  return `${hoursText} {hour}${absHours === 1 ? "" : "s"} ${diffMinutes > 0 ? "ahead" : "behind"}`;
};
